import React, { useState, useEffect } from "react";
import dots from "../assets/images/dots.svg";
import { Link } from "react-router-dom";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import Modal from "react-bootstrap/Modal";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import http from "../services/http";
import moment from "moment";
import { SpinnerCircular } from "spinners-react";
import ReactPaginate from "react-paginate";
// import arrowleft from "../assets/images/arrow-left.png";
import dropdown from "../assets/images/dropdown.png";

export default function EvoOrders() {
  const [key, setKey] = useState("home");
  const [showModal, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [toggle, setToggle] = useState(true);

  const [evo, setEvorders] = useState([]);
  const [evoprogress, setProgress] = useState([]);
  const [complete, setComplete] = useState([]);
  const token = localStorage.getItem("xAuthToken");
  const [loading, setLoading] = useState(false);
  const [lastPage, setLastPage] = useState(0);
  const [lastPageNumber, setLastPageNumber] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [category, setCotegory] = useState([]);
  const [team_id, setTeamId] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchEvoOrders, setSearchEvoOrders] = useState([])
  const [searchEvoOrdersInProgress, setSearchEvoOrdersInProgress] = useState([])
  const [searchEvoOrdersCompleted, setSearchEvoOrdersCompleted] = useState([])  

  const usersPerPage = 7;


  useEffect(() => {
    EvoOrders();
    searchByTeam();
  }, []);

  const searchByTeam = () => {
    http
      .get(`api/admin/team?token=${token}`)
      .then((res) => {
        console.log("response----->", res.data);
        setCotegory(res.data);

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const handleChanges = (event) => {
    setTeamId(event.target.value);
    InProgress(key, event.target.value);
  };

  const EvoOrders = async () => {
    setLoading(true);
    let apiPath = `api/admin/order/all?token=${token}`;
    if (team_id) {
      apiPath += `&team_id=${team_id}`;
    }
    http
      .get(apiPath)
      .then((res) => {
        const evoorders = res.data;
        setEvorders(evoorders);
        setSearchEvoOrders(evoorders)
        setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
        setLastPage(Math.ceil(res.data.length / usersPerPage));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const InProgress = (k, teamId = 0) => {
    setKey(k);
    setPageNumber(0);
    setSearchQuery("")
    let temId = teamId || team_id;
    switch (k) {
      case "home":
        setLoading(true);

        let apiPathall = `api/admin/order/all?token=${token}`;
        if (temId) {
          apiPathall += `&team_id=${temId}`;
        }
        http
          .get(apiPathall)
          .then((res) => {
            console.log("all----", res.data);

            const evoorders = res.data;
            setEvorders(evoorders);
            setSearchEvoOrders(evoorders)
            setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
        break;
      case "Completed":
        setLoading(true);
        let apiPathcomp = `api/admin/order/all?status=Completed&token=${token}`;
        if (temId) {
          apiPathcomp += `&team_id=${temId}`;
        }

        http
          .get(apiPathcomp)
          .then((res) => {
            console.log("completed----", res.data);

            const evoorders = res.data;
            setComplete(evoorders);
            setSearchEvoOrdersCompleted(evoorders)
            setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
        break;
      default:
        setLoading(true);
        let apiPath = `api/admin/order/all?status=inprogress&token=${token}`;
        if (temId) {
          apiPath += `&team_id=${temId}`;
        }
        http
          .get(apiPath)
          .then((res) => {
            console.log("inprogress----", res.data);

            setProgress(res.data);
            setSearchEvoOrdersInProgress(res.data)
            setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setLoading(true);
          });
        break;
    }
  };

  const pagesVisited = pageNumber * usersPerPage;
  const lastPageNumberAllKey = searchEvoOrders.length % usersPerPage == 0 ? usersPerPage : searchEvoOrders.length % usersPerPage
  const lastPageNumberProgressKey = searchEvoOrdersInProgress.length % usersPerPage == 0 ? usersPerPage : searchEvoOrdersInProgress.length % usersPerPage
  const lastPageNumberCompletedKey = searchEvoOrdersCompleted.length % usersPerPage == 0 ? usersPerPage : searchEvoOrdersCompleted.length % usersPerPage
  const pageCount = Math.ceil(searchEvoOrders.length / usersPerPage);
  const pageCountEvoprogress = Math.ceil(searchEvoOrdersInProgress.length / usersPerPage);
  const pageCountComplete = Math.ceil(searchEvoOrdersCompleted.length / usersPerPage);
  const listEvo = evo.length;

  const listEvoprogress = evoprogress.length;
  const listcomplete = complete.length;
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const handleSearchChange = (event) => {
    setPageNumber(0);
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);
    filterEvoOrders(query);
    filterEvoOrdersInProgress(query);
    filterEvoOrdersComplete(query);
  };

  const filterEvoOrders = (query) => {
    if (!query) {
      setSearchEvoOrders(evo);
      return;
    }

    const filtered = evo.filter(
      (s) =>
        `${s.analystFirstName}`.toLowerCase().includes(query) ||
        `${s.analystLastName}`.toLowerCase().includes(query) ||
        `${s.parentFirstname}`.toLowerCase().includes(query) ||
        `${s.parentLastname}`.toLowerCase().includes(query) 
    );
    setSearchEvoOrders(filtered);
  };

  const filterEvoOrdersInProgress = (query) => {
    if (!query) {
      setSearchEvoOrdersInProgress(evoprogress);
      return;
    }

    const filteredInProgress = evoprogress.filter(
      (s) =>
        `${s.parentFirstname}`.toLowerCase().includes(query) ||
        `${s.parentLastname}`.toLowerCase().includes(query) ||
        `${s.analystFirstName}`.toLowerCase().includes(query) ||
        `${s.analystLastname}`.toLowerCase().includes(query)
    );
    setSearchEvoOrdersInProgress(filteredInProgress);
  };

  const filterEvoOrdersComplete = (query) => {
    if (!query) {
      setSearchEvoOrdersCompleted(complete);
      return;
    }

    const filteredCompleted = complete.filter(
      (s) =>
        `${s.parentFirstname}`.toLowerCase().includes(query) ||
        `${s.parentLastname}`.toLowerCase().includes(query) ||
        `${s.analystFirstName}`.toLowerCase().includes(query) ||
        `${s.analystLastname}`.toLowerCase().includes(query)
    );
    setSearchEvoOrdersCompleted(filteredCompleted);
  };
  
  return (
    <>
      <div className="wrapper">
        {toggle && <Nav />}
        <div id="content">
          <header>
            <div className="dashboard_header">
              <div className="left-side d-flex ">
                {" "}
                {/*  <button
                  type="button"
                  id="sidebarCollapse"
                  onClick={() => setToggle(!toggle)}
                  className="btn btn-link bt_none"
                >
                  {" "}
                  <img src={arrowleft} className="img-fluid" />{" "}
                </button> */}
                <h1>Evo Orders</h1>
              </div>
              <DropdownRight />
            </div>
          </header>
          <div className="dashbord_content">
            <div className="analysts-wraper-head">
              <div className="personal_and_bank_info Analysts_tabs Intermediate ">
                <div className="map_btn">
                  <div class="form-group icon mx-0 Edit_Setting">
                  <input
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={handleSearchChange}
                      style={{
                        padding: 10,
                        border: "none",
                        borderRadius: 4,
                        width:300,
                        height:60,
                        backgroundColor:"#f6f6f6"
                      }}
                    />
                  </div>
                </div>

                <Tabs
                  activeKey={key}
                  onSelect={(k) => InProgress(k)}
                  style={{
                    alignItems: "center",
                    width: 480,
                    borderRadius: 5,
                    // marginTop: 50,
                    backgroundColor: "#f6f6f6",
                    padding: 10,
                  }}
                  defaultActiveKey="profile"
                  id="uncontrolled-tab-example"
                  className="mb-3 nav nav-pills border-bottom-0"
                >
                  <Tab eventKey="home" title="All" style={{ marginTop: 40 }}>
                    <div className="table_vedio_upload dashbord_table mb_30 mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            {/* <th scope="col" className="  pl_25">
                              Order ID
                            </th> */}
                            <th scope="col" className=" ">
                              Parent Name
                            </th>
                            <th scope="col" className=" ">
                              Analyst Name
                            </th>
                            <th scope="col" className=" ">
                              Team
                            </th>
                            <th scope="col" className=" ">
                              Package
                            </th>
                            <th scope="col" className=" ">
                              Date Placed
                            </th>
                            <th scope="col" className="  text-center">
                              Status
                            </th>
                            <th scope="col" className="  ">
                              {" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <div
                              style={{
                                position: "absolute",
                                marginTop: 250,
                                backgroundColor: "#ffffffc2",
                                marginLeft: 580,

                                backgroundBlendMode: "overlay",
                                zIndex: 100,
                              }}
                            >
                              <SpinnerCircular size="15%" />
                            </div>
                          ) : (
                            <>
                              {searchEvoOrders
                                .slice(
                                  pagesVisited,
                                  pagesVisited + usersPerPage
                                )
                                ?.map((item) => (
                                  <tr>
                                    <>
                                      {/* <td className="pl_25">{item.id} </td> */}
                                      <td>
                                        {item.parentFirstname}{" "}
                                        {item.parentLastname}
                                      </td>
                                      <td>
                                        {item.analystFirstName}{" "}
                                        {item.analystLastName}
                                      </td>
                                      <td>{item.teamName}</td>
                                      <td>{item.package}</td>
                                      <td>
                                        {moment(item.created_at).format(
                                          "MMM Do YY"
                                        )}
                                      </td>
                                      <td>
                                        <div className="btn_wraper d-flex justify-content-center  ">
                                          <button
                                            type="button"
                                            className={
                                              "" +
                                              (item.status === "Completed"
                                                ? "them_btn_Subscribed"
                                                : "them_btn_Unsubscribed")
                                            }
                                          >
                                            {item.status === "Inprogress"
                                              ? "In Progress"
                                              : item.status}
                                          </button>{" "}
                                        </div>
                                      </td>

                                      <td className="text-center">
                                        <div className="dropdown wraper_btn">
                                          <button
                                            className="btn dropdown-toggle"
                                            type="button"
                                            data-toggle="dropdown"
                                          >
                                            <Link
                                              to={`/details/${item.id}`}
                                              style={{ width: 10 }}
                                            >
                                              <img
                                                src={dots}
                                                className="img-fulid  "
                                                style={{ width: 25 }}
                                              />
                                            </Link>

                                            <span className="caret"></span>
                                          </button>
                                          <ul className="dropdown-menu">
                                            <li>
                                              <Link to="#">View Profile</Link>
                                            </li>
                                            <li>
                                              <Link
                                                to="#"
                                                className="text-danger"
                                              >
                                                Deactivate
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>
                                      </td>
                                    </>
                                  </tr>
                                ))}
                            </>
                          )}
                        </tbody>
                      </table>
                      <div className="pagination">
                        <div className="paginateText">
                          <p className="text-table-show">
                            {" "}
                            Showing{" "}
                            {/* {pageNumber === lastPage - 1
                              ? lastPageNumber
                              : usersPerPage}{" "}
                            out of {listEvo} entries */}
                            {searchEvoOrders.length != 0 ? (pageNumber === pageCount - 1 ? (pagesVisited + 1 +'-'+(pagesVisited + lastPageNumberAllKey)) : (pagesVisited + 1 +'-'+(pagesVisited + usersPerPage)) ) : 0} out of{" "}
                            {searchEvoOrders.length} entries
                          </p>
                        </div>
                        <div className="reactPaginate">
                          <ReactPaginate
                            previousLabel={"<<"}
                            nextLabel={">>"}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={"paginationBttns"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            activeClassName={"paginationActive"}
                            forcePage={pageNumber}
                          />
                        </div>
                      </div>
                    </div>
                  </Tab>

                  <Tab
                    onSelect={InProgress}
                    eventKey="Progress"
                    title="In Progress"
                    style={{ marginTop: 40 }}
                  >
                    <div className="table_vedio_upload dashbord_table     mb_30 mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            {/* <th scope="col" className="  pl_25">
                              Order ID
                            </th> */}
                            <th scope="col" className=" ">
                              Parent Name
                            </th>
                            <th scope="col" className=" ">
                              Analyst Name
                            </th>
                            <th scope="col" className=" ">
                              Team
                            </th>
                            <th scope="col" className=" ">
                              Package
                            </th>
                            <th scope="col" className=" ">
                              Date Placed
                            </th>
                            <th scope="col" className="  text-center">
                              Status
                            </th>
                            <th scope="col" className="  ">
                              {" "}
                            </th>
                          </tr>
                        </thead>
                        {loading ? (
                          <div
                            style={{
                              position: "absolute",
                              marginTop: 250,
                              backgroundColor: "#ffffffc2",
                              marginLeft: 580,

                              backgroundBlendMode: "overlay",
                              zIndex: 100,
                            }}
                          >
                            <SpinnerCircular size="15%" />
                          </div>
                        ) : (
                          <tbody>
                            {searchEvoOrdersInProgress
                              .slice(pagesVisited, pagesVisited + usersPerPage)
                              ?.map((item) => (
                                <tr>
                                  {/* <td className="pl_25">{item.id}</td> */}
                                  <td>
                                    {item.parentFirstname} {item.parentLastname}
                                  </td>
                                  <td style={{ wordBreak: "break-all" }}>
                                    {item.analystFirstName}{" "}
                                    {item.analystLastName}
                                  </td>
                                  <td>{item.teamName}</td>
                                  <td>{item.package}</td>
                                  <td>
                                    {moment(item.created_at).format(
                                      "MMM Do YY"
                                    )}
                                  </td>
                                  <td>
                                    <div className="btn_wraper d-flex justify-content-center  ">
                                      <button
                                        type="button"
                                        className={
                                          "" +
                                          (item.status === "Completed"
                                            ? "them_btn_Subscribed"
                                            : "them_btn_Unsubscribed")
                                        }
                                      >
                                        {item.status === "Inprogress"
                                          ? "In Progress"
                                          : item.status}
                                      </button>{" "}
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <div className="dropdown wraper_btn">
                                      <button
                                        className="btn dropdown-toggle"
                                        type="button"
                                        data-toggle="dropdown"
                                      >
                                        <Link
                                          to={`/details/${item.id}`}
                                          style={{ width: 10 }}
                                        >
                                          <img
                                            src={dots}
                                            className="img-fulid  "
                                            style={{ width: 25 }}
                                          />
                                        </Link>

                                        <span className="caret"></span>
                                      </button>
                                      <ul className="dropdown-menu">
                                        <li>
                                          <Link to="#">View Profile</Link>
                                        </li>
                                        <li>
                                          <Link to="#" className="text-danger">
                                            Deactivate
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        )}
                      </table>
                      <div className="pagination">
                        <div className="paginateText">
                          <p className="text-table-show">
                            {" "}
                            Showing{" "}
                            {/* {pageNumber === lastPage - 1
                              ? lastPageNumber
                              : usersPerPage}{" "}
                            out of {listEvoprogress} entries */}
                            {searchEvoOrdersInProgress.length != 0 ? (pageNumber === pageCountEvoprogress - 1 ? (pagesVisited + 1 +'-'+(pagesVisited + lastPageNumberProgressKey)) : (pagesVisited + 1 +'-'+(pagesVisited + usersPerPage)) ) : 0} out of{" "}
                            {searchEvoOrdersInProgress.length} entries
                          </p>
                        </div>
                        <div className="reactPaginate">
                          <ReactPaginate
                            previousLabel={"<<"}
                            nextLabel={">>"}
                            pageCount={pageCountEvoprogress}
                            onPageChange={changePage}
                            containerClassName={"paginationBttns"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            activeClassName={"paginationActive"}
                            forcePage={pageNumber}
                          />
                        </div>
                      </div>
                    </div>
                  </Tab>
                  <Tab
                    eventKey="Completed"
                    title="Completed"
                    style={{ marginTop: 40 }}
                  >
                    <div className="table_vedio_upload dashbord_table     mb_30 mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            {/* <th scope="col" className="  pl_25">
                              Order ID
                            </th> */}
                            <th scope="col" className=" ">
                              Parent Name
                            </th>
                            <th scope="col" className=" ">
                              Analyst Name
                            </th>
                            <th scope="col" className=" ">
                              Team
                            </th>
                            <th scope="col" className=" ">
                              Package
                            </th>
                            <th scope="col" className=" ">
                              Date Placed
                            </th>
                            <th scope="col" className="  text-center">
                              Status
                            </th>
                            <th scope="col" className="  ">
                              {" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {searchEvoOrdersCompleted
                            .slice(pagesVisited, pagesVisited + usersPerPage)
                            ?.map((item) => (
                              <tr>
                                {/* <td className="pl_25">{item.id}</td> */}
                                <td>
                                  {item.parentFirstname} {item.parentLastname}
                                </td>
                                <td style={{ wordBreak: "break-all" }}>
                                  {item.analystFirstName}{" "}
                                  {item.analystLastName}
                                </td>
                                <td>{item.teamName}</td>
                                <td>{item.package}</td>
                                <td>
                                  {moment(item.created_at).format("MMM Do YY")}
                                </td>
                                <td>
                                  <div className="btn_wraper d-flex justify-content-center  ">
                                    <button
                                      type="button"
                                      className={
                                        "" +
                                        (item.status === "Completed"
                                          ? "them_btn_Subscribed"
                                          : "them_btn_Unsubscribed")
                                      }
                                    >
                                      {item.status === "Inprogress"
                                        ? "In Progress"
                                        : item.status}
                                    </button>{" "}
                                  </div>
                                </td>
                                <td className="text-center">
                                  <div className="dropdown wraper_btn">
                                    <button
                                      className="btn dropdown-toggle"
                                      type="button"
                                      data-toggle="dropdown"
                                    >
                                      <Link
                                        to={`/details/${item.id}`}
                                        style={{ width: 10 }}
                                      >
                                        <img
                                          src={dots}
                                          className="img-fulid  "
                                          style={{ width: 25 }}
                                        />
                                      </Link>

                                      <span className="caret"></span>
                                    </button>
                                    <ul className="dropdown-menu">
                                      <li>
                                        <Link to="#">View Profile</Link>
                                      </li>
                                      <li>
                                        <Link to="#" className="text-danger">
                                          Deactivate
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      <div className="pagination">
                        <div className="paginateText">
                          <p className="text-table-show">
                            {" "}
                            Showing{" "}
                            {/* {pageNumber === lastPage - 1
                              ? lastPageNumber
                              : usersPerPage}{" "}
                            out of {listcomplete} entries */}
                            {searchEvoOrdersCompleted.length != 0 ? (pageNumber === pageCountComplete - 1 ? (pagesVisited + 1 +'-'+(pagesVisited + lastPageNumberCompletedKey)) : (pagesVisited + 1 +'-'+(pagesVisited + usersPerPage)) ) : 0} out of{" "}
                            {searchEvoOrdersCompleted.length} entries
                          </p>
                        </div>
                        <div className="reactPaginate">
                          <ReactPaginate
                            previousLabel={"<<"}
                            nextLabel={">>"}
                            pageCount={pageCountComplete}
                            onPageChange={changePage}
                            containerClassName={"paginationBttns"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            activeClassName={"paginationActive"}
                            forcePage={pageNumber}
                          />
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
              <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Are you sure?</Modal.Title>
                  <button
                    onClick={handleClose}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    {" "}
                    <span aria-hidden="true">&times;</span>{" "}
                  </button>
                </Modal.Header>
                <Modal.Body>
                  <div className="modal-body">
                    {/*    <p>
                      Lorem ipsum dolor sit amet, consectetur adiet cing elit.
                      nun c non risus condiment loborti
                    </p> */}
                    <div className="row mt-3">
                      <div className="col-12 Edit_Setting">
                        <div className="form-group icon  ">
                          <select
                            name=""
                            className="form-control custom_input w-100"
                          >
                            <option value="">Select Team</option>
                          </select>
                          <div className="img_icon">
                            {" "}
                            <img src="assets/images/dropdown.png" alt="" />{" "}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 Edit_Setting">
                        <div className="form-group icon  ">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Type Analyst Name"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer border-top-0">
                      {" "}
                      <button type="button" className="them_btn_ouline ">
                        Cancel
                      </button>{" "}
                      <button type="button" className="them_btn ">
                        Search
                      </button>{" "}
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
